<template>
    <div style="z-index: 2200;">
        <el-drawer
            :title="dialogTitle"
            :visible="true"
            direction="btt"
            size="75%"
            :before-close="handleClose"
            style="z-index: 10000;"
        >
            <div class="dialog_row">
                <div>
                    <p style="font-size: 12px; line-height: 1.75;color: #666666; margin-bottom: 30px;">
                        <!-- 请提供下列信息以便于我们把您的请求转给相应人员，使您能够尽早得到答复。 -->
                        {{ $t('seek.seek_dialog_tip') }}
                    </p>
                </div>
                <div class="form_row">
                <el-form ref="form"  :rules="rules"  :model="formData" >
                    <el-form-item :label="$t('seek.seek_form_telPhone')" prop="telPhone">
                        <el-input v-model="formData.telPhone"  >
                        </el-input>
                    </el-form-item>
                    <el-form-item :label="$t('seek.seek_form_name')" prop="name">
                        <el-input v-model="formData.name" ></el-input>
                    </el-form-item>
                    <el-form-item :label="finalLabelTitle" prop="username">
                        <el-input v-model="formData.username" ></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('seek.seek_form_company')" prop="company">
                        <el-input v-model="formData.company" ></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('seek.seek_form_email')" prop="email">
                        <el-input v-model="formData.email"  ></el-input>
                    </el-form-item>
                    <el-form-item style="text-align: center;">
                        <el-button type="primary" @click="submit()">{{ $t('seek.seek_btn_submit') }}</el-button>
                    </el-form-item>
                   
                </el-form>
            </div>
            </div>
        </el-drawer>
    </div>
    </template>
    
    <script >
    const regMobile = `/^(+?0?86-?)?1[345789]d{9}$/`;
    export default {
        name: 'productApp',
        components: {
    
        },
        props: {
            title: {
                type: String,
                default: null
            },
            labelTitle: {
                type: String,
                default: "产品名称"
            },
             // other-其他页面进来，没有特殊处理
            // resource-资源中心，先留下联系方式，才可以看资源
            type: {
                type: String,
                default: "other"
            },
        },
        data () {
            return {     
                formData: {
                    username: "",
                },
                rules: {
                  
                    telPhone:[
                        { required: true, message: this.$t('seek.seek_form_telPhone_required'), trigger: 'blur' },
                            //校验手机号的正则：/^1[3456789]\d{9}$/
                        {
                                pattern: /^1[3456789]\d{9}$/,
                                message: this.$t('seek.seek_form_telPhone_pattern'),
                                trigger: "blur",
                        },
                    ],
                  
                },
                dialogTitle: this.$t('seek.seek_dialog_title'),  // 联系我们
            }
        },
        computed: {
            finalLabelTitle() {
                return this.$t('seek.seek_form_productName');
            }
        },
        created() {
        },
        mounted () {
            this.formData.username = this.title
            //  // 确定选中的菜单
            // $('.current').removeClass('current');  
            // $('.product_li').addClass('current');
           
        
        },
        methods: {
          
            handleClose() {
                this.$emit("close")
            },
            submit() {
                var that = this
                this.$refs.form.validate((valid) => {
                    if (valid) {
                       
                        // $.ajax({
                        // 	type: "post",
                        // 	// url : "https://www.icloudweld.com/pushDataToOA.action",
                        // 	url: "http://192.168.21.24:8080/weld_can/pushMessToOA.action",
                        //     data: {
                        //         // username: that.formData.username,
                        // 		// email: that.formData.email,
                        // 		// name: that.formData.name,
                        // 		// company: that.formData.company,
                        // 		// telPhone: that.formData.telPhone,
                        // 	},
                        // 	success: (response) => {
                        //         this.$message.success('提交成功，将在一到三个工作日内与您取得联系！');
                        //         this.$emit("close")
                        // 	}
                        // })
                        const domain = window.location.origin;
                        var messContent = '申请体验------ ';
                        messContent += '电话：'+ (that.formData.telPhone ? that.formData.telPhone : "未填") + ';  ';
                        messContent += '姓名：'+ (that.formData.name ? that.formData.name : "未填") + ';  ';
                        messContent += '产品名字：'+ (that.formData.username ? that.formData.username : "未填") + ';  ';
                        messContent += '企业名称：'+ (that.formData.company ? that.formData.company : "未填") + ';  ';
                        messContent += '邮箱：'+ (that.formData.email ? that.formData.email : "未填") + ';  ';
                        messContent += '请求域名：'+ domain + ';';
                        $.ajax({
                            type: "post",
                            url: "https://www.icloudweld.com/weld_can/pushMessToOA.action",
                            data: {
                                messContent: messContent,
                            },
                            success: (response) => {
                                this.$message.success('提交成功，将在一到三个工作日内与您取得联系！');
                                this.$emit("close")
                            }
                        })
                    } else {
                        that.$nextTick(() => {
                            const isError = document.getElementsByClassName('is-error')
                            if (isError.length) isError[0].scrollIntoView({ block: 'center', behavior: 'smooth' })
                        })


                    }
                });
            }
         
        }
    }
    </script>
    <style scoped>
    ::v-deep .el-dialog__wrapper {
        z-index: 2101 !important;
    }
    .dialog_row {
        padding: 0 30px;
        width: 100%
    }
    .form_row {
        /* width: 40%; */
        margin: 0 auto;
    }
    </style> 
    